import { Components } from '@mui/material';
import { getDenseResponsiveFontSize } from '../watchdutyTheme.utils';

/** Dense UI icons stay at design size (map controls, chevrons, adornments). */
export const MuiSvgIcon: Components['MuiSvgIcon'] = {
  styleOverrides: {
    root: {
      fontSize: getDenseResponsiveFontSize('1.5rem'),
    },
    fontSizeSmall: { fontSize: getDenseResponsiveFontSize('1.25rem') },
    fontSizeLarge: { fontSize: getDenseResponsiveFontSize('2.1875rem') },
    fontSizeInherit: { fontSize: getDenseResponsiveFontSize('1rem') },
  },
};
